module.exports = __webpack_public_path__ + "static/img/honor.4786c79.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/honor.webp
// module id = 0l+Q
// module chunks = 0